import React, {useRef} from 'react';
import Codemirror from 'react-codemirror';
import 'codemirror/mode/javascript/javascript';
import { useDispatch } from 'react-redux'
import { setPenJS } from '../../redux/actions/penActions'


export default function(props) {
    const dispatch = useDispatch()
    // const {pen_js} = useSelector(state => state.penReducer)
        var options = {
            lineNumbers: true,
            mode: 'javascript',
            autoCloseTags: true,
            autoCloseBrackets: true,
            theme: props.theme,
            // readOnly : true
        };
        const inputRef = useRef(null) 

        return (
            <div className="w-1/3">
                <Codemirror ref={inputRef} value={props.js} onChange={(val) => dispatch(setPenJS(val))} options={options} autoFocus={false} />
            </div>
        )
    }


// WEBPACK FOOTER //
// ./src/components/CodeEditorAPI/JS.js